module.exports = __webpack_public_path__ + "img/t4-i5.c56a24e8.jpg";